<ng-container *ngIf="price">
	<ng-container *ngIf="hasLayoutList; else headingPrice">
		<span
			*ngIf="showPresentPrice"
			[ngClass]="{ 'price--special': isSpecial }"
			id="product-{{ uniqueId }}-price"
			[attr.aria-label]="getPriceAsLabel(true)"
			[innerHtml]="getPriceAsLabel()"
		>
		</span>
		<div
			*ngIf="
				enabledIndicateChangedPrice &&
				isChangingOrder &&
				this.price?.orderedPrice !== null &&
				this.price?.orderedPrice !== undefined
			"
			class="changedPriceCurrent"
			[ngClass]="{ 'changedPriceCurrent--notOrderedPrice': !usesOrderedPriceAsCurrent }"
		>
			<cdx-hint
				*ngIf="!usesOrderedPriceAsCurrent && this.price?.orderedPrice !== this.price?.salePrice"
				(click)="openChangedPriceModal()"
				[icon]="iconHint"
				iconFill="currentColor"
				[constrainWidth]="true"
				[hintIconRightAligned]="true"
				[iconWithPointerCursor]="true"
			>
				<span id="product-{{ uniqueId }}-price-salePrice">
					{{ this.price?.salePrice | currency }} {{ isKgItem ? 'per kg' : 'each' }}
				</span>
			</cdx-hint>
			<span *ngIf="usesOrderedPriceAsCurrent" id="product-{{ uniqueId }}-price-orderedPrice">
				{{ this.price?.orderedPrice | currency }} {{ isKgItem ? 'per kg' : 'each' }}
			</span>
		</div>
	</ng-container>
	<ng-template #headingPrice>
		<div class="priceCupAdjustmentDev">
			<h3
				class="heading--2 presentPrice "
				[ngClass]="{ 'price--special': isSpecial,'priceCupAdjustment': isCPUUIAdjustimentOn }"
				[attr.aria-label]="getPriceAsLabel(true)"
				id="product-{{ uniqueId }}-price"
			>
				$
				<em>{{ presentPrice.dollars }}</em>
				<span>
					{{ presentPrice.cents }}
					<ng-container *ngIf="isKgItem"><br />kg</ng-container>
				</span>
			</h3>
		</div>
	</ng-template>
	<div id="product-{{ uniqueId }}-save">
		<div class="previousPrice">
			<ng-container *ngIf="showNonMember && canShowSavings">
				<span class="price price--was" 
					>Non-member<span *ngIf="hasLayoutList" [attr.aria-label]="getSavePriceLabel('Non-member', price.originalPrice)">
						{{ price.originalPrice | currency }}</span
					></span
				>
				<span *ngIf="!hasLayoutList" class="price price--was" [attr.aria-label]="getSavePriceLabel('Non-member', price.originalPrice)">{{ price.originalPrice | currency }}</span>
			</ng-container>

			<span
				class="price price--nonClub"
				*ngIf="(haystackEDRChangesEnabled$ | async) === false && isClubPrice && canShowSavings"
				>Non-club {{ price.originalPrice | currency }}</span
			>
			<span class="price price--was" *ngIf="showWasPrice" [attr.aria-label]="getSavePriceLabel('Was', price.originalPrice)">Was {{ price.originalPrice | currency }}</span>
			<span class="price price--save" *ngIf="showSavePrice" [attr.aria-label]="getSavePriceLabel('Save', price.savePrice)">Save {{ price.savePrice | currency }}</span>
		</div>

		<div
			class="previousPrice"
			*ngIf="enabledIndicateChangedPrice && showOrderedPriceAsWasPriceForItemWithChangedPrice"
		>
			<span class="price price--was" [attr.aria-label]="getSavePriceLabel('Was', price.orderedPrice)">Was {{ this.price.orderedPrice | currency }}</span>
		</div>
	</div>
</ng-container>
